<template>
    <div class="py-4 bg-secondary">
    <div class="profile-page">
        <section class="section-new">
            <div class="container">
                <el-row>
                    <el-col :span="24">
                        <div class="card card-lift shadow border-0 card-address_page mb-3">
                            <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('ozod_muddat.ozod_title')}}</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </section>
        <section class="section py-3">
            <div class="container">
                <card shadow class="card-profile mt--200 card_radius_no" no-body style="margin-bottom: 50px;">
                    <div class="px-4">
                        <div class="mt-2 py-5 text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-11">
                                    <div class="calculator">
                                        <div class="calc-left">
                                            <el-row :gutter="10">
                                                <label>{{$t('ozod_muddat.ozod_jadal_label')}}</label><br/>
                                                <el-col :span="8">
                                                    <el-select v-model="form.year" :placeholder="$t('ozod_muddat.ozod_placeholder_year')" size="mini" clearable>
                                                        <el-option
                                                                v-for="item in years"
                                                                :key="item.value"
                                                                :label="$t(item.title, { val: item.title_value })"
                                                                :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                                <el-col :span="8">
                                                    <el-select v-model="form.month" :placeholder="$t('ozod_muddat.ozod_placeholder_month')" size="mini" clearable>
                                                    <el-option
                                                            v-for="item in months"
                                                            :key="item.value"
                                                            :label="$t(item.title, { val: item.title_value })"
                                                            :value="item.value">
                                                    </el-option>
                                                </el-select>
                                                </el-col>
                                                <el-col :span="8">
                                                    <el-select v-model="form.day" :placeholder="$t('ozod_muddat.ozod_placeholder_day')" size="mini" clearable>
                                                        <el-option
                                                                v-for="item in days"
                                                                :key="item.value"
                                                                :label="$t(item.title, { val: item.title_value })"
                                                                :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                            </el-row>
                                            <label>{{$t('ozod_muddat.ozod_jadal_label_qism')}}</label><br/>
                                            <el-select v-model="form.type" :placeholder="$t('ozod_muddat.ozod_placeholder_part')" size="mini" style="width: 100%; margin-bottom: 20px;" clearable>
                                                <el-option
                                                        v-for="item in types"
                                                        :key="item.value"
                                                        :label="item.title"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <el-button @click="clear">{{$t('ozod_muddat.ozod_tozalash')}}</el-button>
                                            <el-button type="primary" @click="calculate" :disabled="!isOneSelected">{{$t('ozod_muddat.ozod_hisoblash')}}</el-button>
                                        </div>
                                        <div class="calc-right">
                                            <div style="color: #7867F2; font-weight: 700; font-size: 28px; line-height: 40px; margin-bottom: 0;">
                                                <span v-if="form.answer !== null">{{ form.answer }}</span>
                                                <span v-else style="font-size: 20px; color: #c7c7c7;">{{$t('ozod_muddat.ozod_hisoblash_tanlang')}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            form: {
                year: null,
                month: null,
                day: null,
                type: null,
                answer: null
            },
            years: [
                {
                    value: 0,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '1'
                },
                {
                    value: 1,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '2'
                },
                {
                    value: 2,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '3'
                },
                {
                    value: 3,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '4'
                },
                {
                    value: 4,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '5'
                },
                {
                    value: 5,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '6'
                },
                {
                    value: 6,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '7'
                },
                {
                    value: 7,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '8'
                },
                {
                    value: 8,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '9'
                },
                {
                    value: 9,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '10'
                },
                {
                    value: 10,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '11'
                },
                {
                    value: 11,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '12'
                },
                {
                    value: 12,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '13'
                },
                {
                    value: 13,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '14'
                },
                {
                    value: 14,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '15'
                },
                {
                    value: 15,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '16'
                },
                {
                    value: 16,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '17'
                },
                {
                    value: 17,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '18'
                },
                {
                    value: 18,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '19'
                },
                {
                    value: 19,
                    title: 'ozod_muddat.ozod_year',
                    title_value: '20'
                }
            ],
            months: [
                {
                    value: 0,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '1'
                },
                {
                    value: 1,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '2'
                },
                {
                    value: 2,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '3'
                },
                {
                    value: 3,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '4'
                },
                {
                    value: 4,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '5'
                },
                {
                    value: 5,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '6'
                },
                {
                    value: 6,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '7'
                },
                {
                    value: 7,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '8'
                },
                {
                    value: 8,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '9'
                },
                {
                    value: 9,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '10'
                },
                {
                    value: 10,
                    title:  'ozod_muddat.ozod_month',
                    title_value: '11'
                }
            ],
            days: [
                {
                    value: 0,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '6'
                },
                {
                    value: 1,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '7'
                },
                {
                    value: 2,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '8'
                },
                {
                    value: 3,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '9'
                },
                {
                    value: 4,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '10'
                },
                {
                    value: 5,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '11'
                },
                {
                    value: 6,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '12'
                },
                {
                    value: 7,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '13'
                },
                {
                    value: 8,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '14'
                },
                {
                    value: 9,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '15'
                },
                {
                    value: 10,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '16'
                },
                {
                    value: 11,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '17'
                },
                {
                    value: 12,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '18'
                },
                {
                    value: 13,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '19'
                },
                {
                    value: 14,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '20'
                },
                {
                    value: 15,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '21'
                },
                {
                    value: 16,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '22'
                },
                {
                    value: 17,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '23'
                },
                {
                    value: 18,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '24'
                },
                {
                    value: 19,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '25'
                },
                {
                    value: 20,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '26'
                },
                {
                    value: 21,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '27'
                },
                {
                    value: 22,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '28'
                },
                {
                    value: 23,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '29'
                },
                {
                    value: 24,
                    title: 'ozod_muddat.ozod_day',
                    title_value: '30'
                }
            ],
            types: [
                {
                    value: 1,
                    title: '1/5'
                },
                {
                    value: 2,
                    title: '1/4'
                },
                {
                    value: 3,
                    title: '1/3'
                },
                {
                    value: 4,
                    title: '1/2'
                },
                {
                    value: 5,
                    title: '2/3'
                },
                {
                    value: 6,
                    title: '3/4'
                }
            ],
            yearArray :
                [['1/0/0','0/2/12','0/3/0','0/4/0','0/6/0','0/8/0','0/9/0',],
                    ['2/0/0','0/4/24','0/6/0','0/8/0','1/0/0','1/4/0','1/6/0',],
                    ['3/0/0','0/7/6','0/9/0','1/0/0','1/6/0','2/0/0','2/3/0',],
                    ['4/0/0','0/9/18','1/0/0','1/4/0','2/0/0','2/8/0','3/0/0',],
                    ['5/0/0','1/0/0','1/3/0','1/8/0','2/6/0','3/4/0','3/9/0',],
                    ['6/0/0','1/2/12','1/6/0','2/0/0','3/0/0','4/0/0','4/6/0',],
                    ['7/0/0','1/4/24','1/9/0','2/4/0','3/6/0','4/8/0','5/3/0',],
                    ['8/0/0','1/7/6','2/0/0','2/8/0','4/0/0','5/4/0','6/0/0',],
                    ['9/0/0','1/9/18','2/3/0','3/0/0','4/6/0','6/0/0','6/9/0',],
                    ['10/0/0','2/0/0','2/6/0','3/4/0','5/0/0','6/8/0','7/6/0',],
                    ['11/0/0','2/2/12','2/9/0','3/8/0','5/6/0','7/4/0','8/3/0',],
                    ['12/0/0','2/4/24','3/0/0','4/0/0','6/0/0','8/0/0','9/0/0',],
                    ['13/0/0','2/7/6','3/3/0','4/4/0','6/6/0','8/8/0','9/9/0',],
                    ['14/0/0','2/9/18','3/6/0','4/8/0','7/0/0','9/4/0','10/6/0',],
                    ['15/0/0','3/0/0','3/9/0','5/0/0','7/6/0','10/0/0','11/3/0',],
                    ['16/0/0','3/2/12','4/0/0','5/4/0','8/0/0','10/8/0','12/0/0',],
                    ['17/0/0','3/4/24','4/3/0','5/8/0','8/6/0','11/4/0','12/9/0',],
                    ['18/0/0','3/7/6','4/6/0','6/0/0','9/0/0','12/0/0','13/6/0',],
                    ['19/0/0','3/9/18','4/9/0','6/4/0','9/6/0','12/8/0','14/3/0',],
                    ['20/0/0','4/0/0','5/0/0','6/8/0','10/0/0','13/4/0','15/0/0',],
                ],

        monthArray :
            [['0/1/0','0/0/6','0/0/8','0/0/10','0/0/15','0/0/20','0/0/23',],
                ['0/2/0','0/0/12','0/0/15','0/0/20','0/1/0','0/1/10','0/1/15',],
                ['0/3/0','0/0/18','0/0/23','0/1/0','0/1/15','0/2/0','0/2/8',],
                ['0/4/0','0/0/24','0/1/0','0/1/10','0/2/0','0/2/20','0/3/0',],
                ['0/5/0','0/1/0','0/1/8','0/1/20','0/2/15','0/3/10','0/3/23',],
                ['0/6/0','0/1/6','0/1/15','0/2/0','0/3/0','0/4/0','0/4/15',],
                ['0/7/0','0/1/12','0/1/23','0/2/10','0/3/15','0/4/20','0/5/8',],
                ['0/8/0','0/1/18','0/2/0','0/2/20','0/4/0','0/5/10','0/6/0',],
                ['0/9/0','0/1/24','0/2/8','0/3/0','0/4/15','0/6/0','0/6/23',],
                ['0/10/0','0/2/0','0/2/15','0/3/10','0/5/0','0/6/20','0/7/15',],
                ['0/11/0','0/2/6','0/2/23','0/3/20','0/5/15','0/7/10','0/8/8',],
            ],

        dayArray :
            [['0/0/6','0/0/1','0/0/1','0/0/2','0/0/3','0/0/4','0/0/4',],
                ['0/0/7','0/0/1','0/0/1','0/0/2','0/0/3','0/0/4','0/0/5',],
                ['0/0/8','0/0/1','0/0/2','0/0/2','0/0/4','0/0/5','0/0/6',],
                ['0/0/9','0/0/1','0/0/2','0/0/3','0/0/4','0/0/6','0/0/6',],
                ['0/0/10','0/0/2','0/0/2','0/0/3','0/0/5','0/0/6','0/0/7',],
                ['0/0/11','0/0/2','0/0/2','0/0/3','0/0/5','0/0/7','0/0/8',],
                ['0/0/12','0/0/2','0/0/3','0/0/4','0/0/6','0/0/8','0/0/9',],
                ['0/0/13','0/0/2','0/0/3','0/0/4','0/0/6','0/0/8','0/0/9',],
                ['0/0/14','0/0/2','0/0/3','0/0/4','0/0/7','0/0/9','0/0/10',],
                ['0/0/15','0/0/3','0/0/3','0/0/5','0/0/7','0/0/10','0/0/11',],
                ['0/0/16','0/0/3','0/0/4','0/0/5','0/0/8','0/0/10','0/0/12',],
                ['0/0/17','0/0/3','0/0/4','0/0/5','0/0/8','0/0/11','0/0/12',],
                ['0/0/18','0/0/3','0/0/4','0/0/6','0/0/9','0/0/12','0/0/13',],
                ['0/0/19','0/0/3','0/0/4','0/0/6','0/0/9','0/0/12','0/0/14',],
                ['0/0/20','0/0/4','0/0/5','0/0/6','0/0/10','0/0/13','0/0/15',],
                ['0/0/21','0/0/4','0/0/5','0/0/7','0/0/10','0/0/14','0/0/15',],
                ['0/0/22','0/0/4','0/0/5','0/0/7','0/0/11','0/0/14','0/0/16',],
                ['0/0/23','0/0/4','0/0/5','0/0/7','0/0/11','0/0/15','0/0/17',],
                ['0/0/24','0/0/4','0/0/6','0/0/8','0/0/12','0/0/16','0/0/18',],
                ['0/0/25','0/0/5','0/0/6','0/0/8','0/0/12','0/0/16','0/0/18',],
                ['0/0/26','0/0/5','0/0/6','0/0/8','0/0/13','0/0/17','0/0/19',],
                ['0/0/27','0/0/5','0/0/6','0/0/9','0/0/13','0/0/18','0/0/20',],
                ['0/0/28','0/0/5','0/0/7','0/0/9','0/0/14','0/0/18','0/0/21',],
                ['0/0/29','0/0/5','0/0/7','0/0/9','0/0/14','0/0/19','0/0/21',],
                ['0/1/0','0/0/6','0/0/7','0/0/10','0/0/15','0/0/20','0/0/22',],
            ]
        };
    },
    methods: {
        clear(){
            this.form.year = null;
            this.form.month = null;
            this.form.day = null;
            this.form.type = null;
            this.form.answer = null;
        },
        calculate(){
            let total = 0;
            let { year, month, day, type: typeVal } = this.form;
            let type = typeVal || 0;
            if(this.hasYear) {
                total += this.toDays(this.yearArray[year][type]);
            }

            if(this.hasMonth) {
                total += this.toDays(this.monthArray[month][type]);
            }

            if(this.hasDay) {
                total += this.toDays(this.dayArray[day][type]);
            }

            let array = this.dayToYearMonthDay(total).split('/');
            let answer = '';

            if(array[0] != 0){
                answer += array[0] + ' йил ';
            }
            if(array[1] != 0){
                answer += array[1] + ' ой ';
            }
            if(array[2] != 0){
                answer += array[2] + ' кун. ';
            }

            this.form.answer = answer;
        },
        yearToDay(e) {
            return e * 12 * 30;
        },

        monthToDay(e) {
            return e * 30;
        },

        dayToYearMonthDay(e){
            let year = parseInt(e / 30 / 12);
            let month = parseInt(e / 30 % 12);
            let day = e % 30;

            return year + '/' + month + '/' + day;
        },

        toDays(e){
            let array = e.split('/');
            let year = array[0] * 12 *30;
            let month = array[1] * 30;
            let day = array[2] * 1;
            return year + month + day;
        }

    },
    computed: {
        hasDay(){
            let { day } = this.form;
            return day !== null && day !== "";
        },
        hasMonth(){
            let { month } = this.form;
            return month !== null && month !== "";
        },
        hasYear(){
            let { year } = this.form;
            return year !== null && year !== "";
        },
        isOneSelected(){
            return this.hasDay || this.hasMonth || this.hasYear;
        }
    }
};
</script>
<style scoped>
    .calculator {
        display: flex;
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        margin-top: 5px;
        background-color: #f2f3f5;
        padding: 25px;
        flex-flow: row;
    }

    label {
        color: #777;
        font-weight: 400;
        margin-bottom: 8px;
    }
    .calc-left {
        width: 100%;
        padding-right: 25px;
    }

    .calc-right {
        display: flex;
        height: 178px;
        background: #fff;
        width: 60%;
        align-items: center;
        justify-content: center;
        font-size: 25px;
        color: #7867F2;
        border: 2px dotted #ddd;
    }
    select#section {
        width: 100%;
    }

</style>
